import styled, { css, keyframes } from 'styled-components';

export const ProductMainSection = styled.div`
  margin: 24px 2em;

  @media (max-width: 720px) {
    margin: 24px 10px;
  }
`;

export const ProductsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-gap: 46px;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(4, 1fr);
  }

  @media (max-width: 720px) {
    grid-template-columns: repeat(2, 1fr);
    margin: 0;
    grid-gap: 14px;
  }
`;
export const ProductsGridNew = styled(ProductsGrid)`
  grid-template-columns: repeat(4, 1fr);

  @media (max-width: 720px) {
    margin-top: ${(props) => (props.happiness ? '-12px' : '0')};
    grid-template-columns: repeat(2, 50%);
    grid-gap: 0;
    &.empty_screen {
      display: flex;
      align-items: center;
      width: 100%;
      overflow-x: scroll;
      overflow-y: hidden;
      scroll-behavior: smooth;
    }
  }
`;

export const CategoryTitleCTASection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 720px) {
    padding: 0 0 16px 10px;
  }

  h2 {
    font-size: clamp(16px, 2vw, 22px);
    letter-spacing: 1px;
    color: hsl(0deg, 0%, 0%, 80%);
  }

  button {
    background: #fff;
    outline: none;
    border: none;
    font-family: 'Montserrat';
    font-size: clamp(16px, 2vw, 18px);
    font-weight: 600;
    letter-spacing: 3px;
    color: hsl(0deg, 0%, 0%, 80%);
    display: flex;
    align-items: center;
    cursor: pointer;

    @media (max-width: 720px) {
      cursor: default;
      display: none;
    }

    img {
      width: 18px;
      height: 18px;
      transform: rotate(270deg);
    }
  }
`;

const fadeInUp = keyframes`
 0% {
    opacity: 0;
    transform: translateY(20px);
  }

  100% {
    opacity: 1;
    transform: translateY(0px);
  }
`;

export const CategoryProductMain = styled.section`
  margin: ${(props) => (props.headingPresent ? '40px 10px' : '0')};

  &.animateFromBottom {
    animation: ${fadeInUp} 0.75s ease-in-out;
  }
  @media (max-width: 720px) {
    margin: 0 0 40px;
  }
`;

export const DefaultImageSection = styled.div`
  width: 100%;
  height: 100%;
  background: url('https://images.myloapp.in/NestJsUploads/1668581912764-defaultimage.webp');
  background-size: contain;
  background-position: center;
  border-radius: 10px 10px 0 0;
  position: relative;
  padding-top: 100%;
`;

export const ProductImage = styled.img`
  width: 100%;
  border-radius: ${(props) => (props.home ? '4px 4px 0 0' : '10px 10px 0 0')};
  position: absolute;
  top: 0;
`;

export const ProductCard = styled.div`
  width: 100%;
  max-width: 216px;
  border-radius: 10px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
  background-color: #fff;
  cursor: pointer;
  display: flex;
  flex-direction: column;

  @media (max-width: 720px) {
    min-width: 50%;
    cursor: auto;
  }
`;

export const ProductSectionTitle = styled.h2`
  margin: 58px 0 30px;
  font-size: clamp(18px, 4vw, 24px);
  color: #63b0a8;

  @media (max-width: 720px) {
    padding: 0 10px;
    margin: 30px 0 30px;
  }
`;

export const ProductDetail = styled.div`
  padding: 7px 10px 10px;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const ProductName = styled.h3`
  font-weight: 500;
  font-size: 14px;
  color: hsl(0deg, 0%, 0%, 80%);
  overflow: hidden;
  padding: 4px 0 0;
  width: 100%;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin: 0;
`;

export const RatingSection = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 0;

  & .rating {
    font-size: 14px;
    color: hsl(0deg, 0%, 0%, 68%);
    font-weight: 500;
  }
  & .totalRatings {
    padding-left: 4px;
    color: hsl(0deg, 0%, 0%, 87%);
    font-size: 12px;
  }
  & img {
    margin-right: 5px;
  }
`;

export const ProductPriceDetail = styled.div`
  display: flex;
  align-items: baseline;
  padding-bottom: 10px;

  .mainPrice {
    font-weight: 500;
    padding-right: 6px;
    font-size: clamp(16px, 2vw, 18px);
  }
  .strikePrice {
    text-decoration: line-through;
    font-size: 12px;
    padding-right: 6px;
    font-weight: 500;
    color: #9d9d9d;
  }
  .discount {
    font-size: 12px;
    color: #63b0a8;
    font-weight: 500;
  }
`;

export const LoadMoreSec = styled.div`
  text-align: center;
  margin: 46px 0 16px;

  @media (max-width: 720px) {
    margin: 16px 0;
  }
`;

export const ProductCTA = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: ${(props) => (props.loadmore ? '100%' : 'auto')};
  cursor: pointer;
  outline: none;
  box-shadow: none;
  background-color: ${(props) => (props.verm ? '#ef4e5e' : '#fff')};
  color: ${(props) => (props.verm ? '#fff' : '#ef4e5e')};
  text-align: center;
  font-size: ${(props) => (props.loadmore ? '16px' : '14px')};
  text-transform: uppercase;
  margin: auto;
  border: ${(props) =>
    props.verm
      ? 'none'
      : props.loadmore
        ? '1px solid #ef4e5e'
        : '1px solid #ef4e5e'};
  height: ${(props) => (props.loadmore ? '50px' : '32px')};
  line-height: ${(props) => (props.loadmore ? '50px' : '32px')};
  border-radius: 5px;
  font-weight: 500;

  &:hover {
    background-color: ${(props) => (props.loadmore ? '#f2f2f2bf' : 'auto')};
  }

  img {
    width: 13px;
    height: 11px;
    margin-left: 10px;
  }
  @media (max-width: 720px) {
    min-width: 50%;
    cursor: auto;
    font-size: 14px;
  }
`;

export const ProductNewMainSection = styled.div`
  flex-basis: 44%;
  margin: ${(props) =>
    props.article
      ? '10px 13px 0'
      : props.storeHome
        ? '0 32px 0 0'
        : props.DoubleGrid
          ? '10px 12px 0'
          : '10px 0 0'};
  cursor: pointer;
  border-radius: ${(props) =>
    props.isForNewCdPage ? '8px' : props.DoubleGrid ? '' : '4px'};
  overflow: ${(props) => (props.hideAddToCart ? 'unset' : 'hidden')};
  flex-shrink: ${(props) => props.shrink};
  @media (max-width: 720px) {
    margin: ${(props) =>
      props.DoubleGrid
        ? props.isForNewCdPage
          ? '4px 7px 10px'
          : '4px 7px 24px'
        : '10px 10px'};
    padding-right: ${(props) => (props.DoubleGrid ? '5px' : '0')};
    cursor: default;
    flex-basis: ${(props) => props.mobileWidth};
    max-width: ${(props) => props.mobileMaxWidth};
    min-width: ${(props) => props.mobileMinWidth};
  }
  flex-basis: ${(props) => props.maxWidth};
  transition:
    all 0.3s cubic-bezier(0.155, 1.105, 0.295, 1.12) 0s,
    box-shadow 0.3s ease 0s;

  &.lowOpacity {
    opacity: 0.4;
  }

  .animated_card {
    position: relative;
    top: ${(props) => (props.hideAddToCart ? '0px' : '48px')};
    transition: all 0.25s ease-out;
    height: 100%;
    display: flex;
    flex-direction: column;

    @media (max-width: 720px) {
      top: 0;
    }
  }

  &.hoverable_section {
    &:hover {
      .add_btn_filled {
        opacity: 1;
      }
      .animated_card {
        top: 0;
      }
    }
  }

  background-color: ${(props) => (props.isForNewCdPage ? '#fff' : '')};
`;

export const ProductNewImageSection = styled.div`
  width: 100%;
  height: auto;
  background: ${(props) =>
    props.DoubleGrid
      ? ''
      : 'url(https://images.myloapp.in/NestJsUploads/1668581912764-defaultimage.webp) center center / contain'};
  border-radius: 10px 10px 10px 10px;
  position: relative;
  padding-top: 100%;
  img {
    border-radius: 0 6px 0 0px;
  }
`;

export const ProductsNewGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 46px;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(4, 1fr);
  }

  @media (max-width: 720px) {
    grid-template-columns: repeat(2, 1fr);
    margin: 24px 0;
    grid-gap: 14px;
  }
`;

export const ProductNewImage = styled.img`
  width: 100%;
  border-radius: 6px;
  position: absolute;
  top: 0;
  object-fit: fill;
  aspect-ratio: 1;
`;
export const ProductNewImageDiv = styled.div`
  width: 100%;

  .lowOpacity {
    opacity: 0.4;
  }

  .view-360-btn {
    position: absolute;
    z-index: 2;
    bottom: 10px;
    left: 10px;
    width: 48%;
    height: 20px;
    flex-grow: 0;
    font-family: Montserrat;
    font-size: 12px;
    font-weight: 500;
    text-align: center;
    color: #434343;
    background-color: white;
    border: none;
    border-radius: 10px;
    cursor: pointer;

    &:hover {
      background-color: #f8f8f8;
      box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15);
    }
  }
`;
export const ProductNewPriceDetail = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: ${(props) => props.justify};
  padding: ${(props) => (props.bogo ? '4px 0 10px' : '10px 0 0')};

  .mainPrice {
    font-weight: 500;
    padding-right: 8px;
    font-size: ${(props) =>
      props.bogo
        ? 'clamp(12px,2vw,14px)'
        : props.search
          ? 'clamp(14px, 2vw, 18px)'
          : 'clamp(16px, 2vw, 18px)'};
  }

  .strikePrice {
    text-decoration: line-through;
    font-size: ${(props) =>
      props.bogo
        ? 'clamp(10px,2vw,12px)'
        : props.search
          ? 'clamp(13px,2vw,14px)'
          : '14px'};
    padding-right: 8px;
    font-weight: 500;
    color: #9d9d9d;
  }

  .discount {
    font-size: ${(props) =>
      props.bogo
        ? 'clamp(10px,2vw,12px)'
        : props.search
          ? 'clamp(13px,2vw,14px)'
          : '14px'};
    color: #63b0a8;
    font-weight: 500;
  }
`;

export const RatingCard = styled.div`
  margin: 10px 0;
`;

export const RatingImg = styled.img`
  width: 20px;
  height: 20px;
  margin: 0 4px;
`;

export const VariantName = styled.p`
  font-size: ${(props) => (props.perUnit ? 'clamp(10px, 2vw, 12px);' : '12px')};
  font-weight: 500;
  color: ${(props) =>
    props.perUnit ? 'rgb(0 0 0 / 38%)' : 'rgb(0 0 0 / 80%)'};
  padding-top: 10px;
  display: ${(props) => (props.searchallProduct ? 'none' : 'block')};
`;

export const AddToCartButtonFilled = styled.div`
  &.add_btn_filled {
    border-radius: ${(props) =>
      props.isForNewCdPage ? '4px' : props.newUI ? '12px' : '2px'};
    background-color: ${(props) =>
      props.verm || props.loaderState
        ? '#ef4e5e'
        : props.newUI
          ? '#ffedef'
          : '#fff'};
    color: ${(props) =>
      props.verm || props.loaderState
        ? '#fff'
        : props.isForNewCdPage
          ? '#ef4e5e'
          : '#040404'};
    border: ${(props) =>
      props.verm || props.loaderState
        ? '1px solid #ef4e5e'
        : props.newUI
          ? ''
          : props.isForNewCdPage
            ? '1px solid #ef4e5e'
            : '1px solid #040404'};
    height: ${(props) =>
      props.listTemplate ? '46px' : props.bogo ? '36px' : '42px'};
    line-height: ${(props) =>
      props.listTemplate ? '46px' : props.bogo ? '36px' : '42px'};
    margin: auto auto 0;
    display: block;
    width: 100%;
    max-width: ${(props) => (props.listTemplate ? '60%' : '100%')};
    font-size: ${(props) => (props.listTemplate ? '16px' : '13px')};
    font-weight: 600;
    text-align: center;
    cursor: pointer;
    transition: all 0.1s ease-in-out 0s;

    &.lowOpacity {
      opacity: 0.4;
    }

    &:hover {
      background-color: #ef4e5e;
      color: #fff;
      border: 1px solid #ef4e5e;
    }

    ${(props) =>
      props.newUI
        ? css`
            position: absolute;
            bottom: 10px;
            width: 90%;
            left: 50%;
            transform: translateX(-50%);
            color: ${(props) =>
              props.verm || props.loaderState ? '#fff' : '#ef4e5e'};
          `
        : css``};
    @media (max-width: 720px) {
      max-width: 100%;
      cursor: default;
      font-size: ${(props) => (props.smallButton ? '11px' : '13px')};
      height: ${(props) =>
        props.isForNewCdPage
          ? '33px'
          : props.bogo || props.smallButton
            ? '30px'
            : '40px'};
      line-height: ${(props) =>
        props.isForNewCdPage
          ? '30px'
          : props.bogo || props.smallButton
            ? '30px'
            : '40px'};
    }

    &.newView {
      position: unset;
      transform: translate(0, 0);
      margin-left: 0;
      border-radius: 8px;
      width: 75%;
      @media (min-width: 768px) {
        display: none;
      }
    }
  }
`;
export const OutOfStock = styled.div`
  border-radius: 2px;
  background-color: #d9d9d9;
  color: #fff;
  height: 42px;
  line-height: 42px;
  margin: auto auto 0;
  display: block;
  width: 100%;
  max-width: 100%;
  font-size: 13px;
  font-weight: 600;
  text-align: center;
  cursor: pointer;
  transition: all 0.1s ease-in-out 0s;

  @media (max-width: 720px) {
    max-width: 100%;
    cursor: default;
    font-size: 11px;
    height: 30px;
    line-height: 30px;
  }
`;
export const ProductNewSectionTitle = styled.h3`
  font-size: 14px;
  color: hsl(0deg 0% 0% / 87%);
  overflow: hidden;
  padding: 9px 0 0;
  width: 100%;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin: 0;
  text-align: ${(props) => (props.search ? 'center' : 'left')};
  font-weight: 500;
  height: ${(props) => (props.search ? '44.6px' : '42.6px')};
`;
